// ============================================================================
// BLOOM FILTER - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'bloom-filter',
  name: 'Bloom Filter',
  category: 'Data Structures',
  complexity: {
    time: 'O(k) per operation',
    space: 'O(m)'
  },
  description: 'A space-efficient probabilistic data structure for testing set membership. May return false positives but never false negatives. Uses multiple hash functions to map elements to bits in a bit array.'
};
